import { defaultShouldDehydrateQuery, QueryClient } from "@tanstack/react-query"
import SuperJSON from "superjson"
import { TRPCClientError } from "@trpc/client"

export const createQueryClient = () =>
	new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 30 * 1000,
				refetchOnWindowFocus: false,
				retry: (failureCount, error) => {
					if (
						error instanceof TRPCClientError &&
						(error.data?.code === "UNAUTHORIZED" ||
							error.data?.code === "FORBIDDEN")
					)
						return false
					return failureCount < 3
				}
			},
			dehydrate: {
				serializeData: SuperJSON.serialize,
				shouldDehydrateQuery: (query) =>
					defaultShouldDehydrateQuery(query) || query.state.status === "pending"
			},
			hydrate: {
				deserializeData: SuperJSON.deserialize
			}
		}
	})
